import './BuyingServices.css';

function BuyingServices() {
  return (
    <div className="buying-services">
      <div className="container">
        <section className="buying-content">
          <div className="service-details">
            <h2>What I Do for Buyers</h2>
            <p>
              I make the home-buying process exciting, streamlined, and tailored to your needs.
            </p>
            
            <div className="buying-process">
              <h3>My Proven Buying Process</h3>
              <div className="process-steps">
                <div className="step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h4>Personalized Search</h4>
                    <p>I take the time to understand your budget, location preferences, home requirements, school districts, and loan qualifications.</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h4>Access to Lenders</h4>
                    <p>With connections to over 120 lenders, I help you explore financing options that work for your situation.</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h4>Property Selection</h4>
                    <p>I identify homes that match your criteria and give you a clear picture of what's available.</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">4</div>
                  <div className="step-content">
                    <h4>Trusted Contractor Referrals</h4>
                    <p>Get free estimates on upgrades or renovations before making offers.</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">5</div>
                  <div className="step-content">
                    <h4>Negotiation & Offers</h4>
                    <p>I handle the strategy and details to get you the best terms.</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-number">6</div>
                  <div className="step-content">
                    <h4>Closing Support</h4>
                    <p>From contract to keys, I make sure every step is handled smoothly.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <section className="contact-section">
          <div className="contact-card">
            <h3>Ready to Find Your Dream Home?</h3>
            <p>Let's discuss your home buying goals and create a personalized strategy for your needs.</p>
            <div className="contact-buttons">
              <span className="phone-desktop">(650) 283-3537</span>
              <a href="tel:650-283-3537" className="phone-mobile contact-btn primary">Call (650) 283-3537</a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default BuyingServices;